<template lang="pug">
v-tab-item
    feathers-vuex-find(
        service="bh-user-survey-custom"
        :query="dataQuery"
        :fetch-query="fetchQuery"
        watch="query"
    )
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title User Survey Manager
                v-spacer
                //- v-text-field(
                //-     v-model="searchUser"
                //-     append-icon="mdi-magnify"
                //-     label="Search"
                //-     single-line
                //-     hide-details
                //- )
                add-user-survey(@success="success = true")
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )
                template(v-slot:item.set_name="{ item }") {{ item.user.fname }} {{ item.user.lname }}
                template(v-slot:item.actions="{ item }")
                    update-user-survey(:item="item" @success="success = true")
                    delete-user-survey(:id="item.id" @success="successDelete = true")
                    //- v-btn.ml-3(small color="red" dark outlined rounded @click="deleteCustomSurvey(item.id)")
                    //-     v-icon mdi-delete
                    //-     | Delete
                

    v-snackbar(top v-model="success" color="success") Successfully Saved!
    v-snackbar(top v-model="successDelete" color="success") Successfully Deleted!
    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
            
</template>

<script>
import moment from 'moment';
import UpdateSurveyOptions from './UpdateSurveyOptions.vue';
import UpdateUserSurvey from './UpdateUserSurvey.vue';
import DeleteUserSurvey from './DeleteUserSurvey.vue';
import AddUserSurvey from './AddUserSurvey.vue';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            searchUser: '',
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                    width: 100
                },
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'set_name'
                },
                {
                    text: 'Actions',
                    sortable: false,
                    align: 'end',
                    value: 'actions'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: []
            },
            query: {},
            error: {
                show: false,
                message: ''
            },
            success: false,
            successDelete: false
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { set_name: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { set_name: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
                            $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
        ...mapGetters('bh-survey-option-tree', { getSuveyData: 'get' })
    },
    methods: {
        onError(message) {
            this.error.message = message;
            this.error.show = true;
        },
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        }
    },
    components: {
        UpdateSurveyOptions,
        AddUserSurvey,
        UpdateUserSurvey,
        DeleteUserSurvey
    }
}
</script>